import { PERSISTENCE_KEYS } from 'common/constants/persistence.constants';
import { atomWithWebStorage } from 'common/utils/atom.utils';

type TSelectedCounterparty = string;

export const selectedCounterpartyAtom = atomWithWebStorage<TSelectedCounterparty>(
  PERSISTENCE_KEYS.ACCOUNT_MANAGEMENT_SELECTED_COUNTERPARTY,
  '',
);
